// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { Asset } from './asset';
import { CurrencyType } from './currency-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CurrencyRate extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  currencyRateId!: number;
  createdBy!: string;
  createdDate!: Date;
  flags!: number;
  fromCurrencyTypeCurrencyTypeId!: number;
  rate!: number;
  rateDate!: Date;
  reciprocal!: number;
  toCurrencyTypeCurrencyTypeId!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  accounts!: Account[];
  assets!: Asset[];
  fromCurrencyTypeCurrencyType!: CurrencyType;
  toCurrencyTypeCurrencyType!: CurrencyType;
}

